import React, { useState } from "react";
import { ReactComponent as LineTop_icon } from "../../style/images/line_top.svg";
import "./slider.css";
import { IMG_URL } from "../../api";
const HorizontalSlider = ({ images, selectedIndex, setSelectedIndex }) => {
  const [touchStartX, setTouchStartX] = useState(null);
  const [touchMoveX, setTouchMoveX] = useState(null);

  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
    setTouchMoveX(null);
  };

  const handleTouchMove = (e) => {
    if (touchStartX !== null) {
      setTouchMoveX(e.touches[0].clientX);
    }
  };

  const handleTouchEnd = () => {
    if (touchStartX !== null && touchMoveX !== null) {
      handleSwipe();
    }
    setTouchStartX(null);
    setTouchMoveX(null);
  };

  const handleSwipe = () => {
    const swipeThreshold = 50;

    if (touchStartX - touchMoveX > swipeThreshold) {
      handleNext();
    } else if (touchMoveX - touchStartX > swipeThreshold) {
      handlePrev();
    }
  };

  const handlePrev = () => {
    const currentIndex = images.findIndex((img) => img === selectedIndex);
    const newIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
    setSelectedIndex(images[newIndex]);
  };

  const handleNext = () => {
    const currentIndex = images.findIndex((img) => img === selectedIndex);
    const newIndex = currentIndex === images.length - 1 ? 0 : currentIndex + 1;
    setSelectedIndex(images[newIndex]);
  };

  return (
    <div
      className="carousel-container-horisontal"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <button
        className="carousel-button-horisontal carousel-button-prev-horisontal"
        onClick={handlePrev}
      >
        <LineTop_icon />
      </button>
      <div className="carousel-wrapper-horisontal">
        <div className="carousel-content-horisontal">
          {images.map((image, index) => (
            <div
              key={index}
              onClick={() => setSelectedIndex(image)}
              className={`carousel-item-horisontal ${
                image === selectedIndex ? "active" : ""
              }`}
              style={{
                transform: `translateX(-${
                  images.indexOf(selectedIndex) * 100
                }%)`,
              }}
            >
              <img src={image} alt={`Slide ${index}`} />
            </div>
          ))}
        </div>
      </div>
      <button
        className="carousel-button-horisontal carousel-button-next-horisontal"
        onClick={handleNext}
      >
        <LineTop_icon />
      </button>
    </div>
  );
};

export default HorizontalSlider;
